import React from "react"
import Drawer from "./components/Drawer"
import { Content, Header, Wrapper } from "./index.styles"

interface IProps {
  title?: string
  questions?: {
    title: string
    answer: string
  }[]
  color?: string
}

const Drawers = ({ title, questions, color }: IProps) => (
  <Wrapper>
    <Header color={color}>{title}</Header>
    <Content color={color}>
      {(questions || []).map((q, i) => (
        <Drawer key={i} title={q.title}>
          {q.answer}
        </Drawer>
      ))}
    </Content>
  </Wrapper>
)

Drawers.defaultProps = {
  title: "People often ask",
  questions: [],
  color: "#F15A24",
}

export default Drawers
